import * as React from 'react';

interface Props {
    className: string;
    onClick?: () => void;
}

export default class PropertyList extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    handleClick = (evt: React.MouseEvent): void => {
        const { onClick } = this.props;

        if (onClick) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();
            onClick();
        }
    };

    render() {
        const { children, className } = this.props;

        let classNames: Array<string> = ['ddbc-property-list', className];

        return (
            <div className={classNames.join(' ')} onClick={this.handleClick}>
                {children}
            </div>
        );
    }
}
